import {Component, Inject, OnInit} from '@angular/core';
import {GlobalConstants} from "../../../../common/global-constants";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../../services/data.service";
import {ConfigurationService} from "../../../../services/configuration.service";
import {validApprover} from "../../../../services/validation.service";
import {AuthenticationService} from "../../../../services/authentication.service";
import {CommonUtils} from "../../../../utils/common.utils";

@Component({
  selector: 'app-update-transit-time',
  templateUrl: './update-transit-time.component.html',
  styleUrls: ['./update-transit-time.component.scss']
})

export class UpdateTransitTimeComponent implements OnInit {

  updateTransitTimeURL: string = GlobalConstants.PROCESS_TRANSIT_TIME_REQUEST_ENDPOINT;
  updateTransitTimeForm: FormGroup;

  transitTimeOptions: any = [];
  fromCountryCodeOptions: any = [];

  transitTimeConfigurationRecords: any = [];
  selectedFile: File = null;
  loading = false;
  currentWorkingRecord: any;
  currentComponentKeyPlaceholder: any = [];

  single = GlobalConstants.SINGLE_KEYWORD;
  range = GlobalConstants.RANGE_KEYWORD;
  singleTransitTimeColumns: any = [];
  rangeTransitTimeColumns: any = [];

  help_messages: any = this.dataService.help_messages;

  dropDownOptions: any = {};
  items: any = {};

  user = {};

  get progress() {
    return this.uploadFileServiceUtils.progress;
  }

  get passportEnabledShipmethods(){
    return this.dataService.passportEnabledShipmethods;
  }

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('UploadFileServiceUtils') private uploadFileServiceUtils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dataService: DataService) {

  }


  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.updateTransitTimeForm = this.formBuilder.group({
      businessUseCase: ['', Validators.required],
      fromCountryCode: ['', Validators.required],
      componentKeyValue: ['', Validators.required],
      componentKeyPlaceholder: [''],
      transitTimeType: ['', Validators.required],
      transitTimeFile: ['', Validators.required]
    });

    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.transitTimeOptions = this.dataService.transitTimeOptions;
    this.items = this.commonUtils.getItemsBasedOnArc();

  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  public onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};
    this.updateTransitTimeForm.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.updateTransitTimeForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue('');
    this.singleTransitTimeColumns = this.rangeTransitTimeColumns = this.currentComponentKeyPlaceholder = [];
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.transitTimeConfigurationRecords = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }


  public onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.dropDownOptions = this.commonUtils.getDropDownOptions(this.currentWorkingRecord, this.transitTimeConfigurationRecords);

    this.updateTransitTimeForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue(this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER])
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.updateTransitTimeForm.setControl(GlobalConstants.COMPONENT_KEY_VALUE, this.getComponentKeyValueFormGroup());

    let lookUpKeyColumns = this.commonUtils.generateLookUpKeyColumns(this.currentWorkingRecord);
    this.singleTransitTimeColumns = lookUpKeyColumns[GlobalConstants.SINGLE_TRANSIT_TIME_COLUMNS];
    this.rangeTransitTimeColumns = lookUpKeyColumns[GlobalConstants.RANGE_TRANSIT_TIME_COLUMNS];

    this.updateTransitTimeForm.get(GlobalConstants.TRANSIT_TIME_TYPE).setValue('');
    this.updateTransitTimeForm.get(GlobalConstants.TRANSIT_TIME_FILE).setValue('');

  }

  public onTransitTimeTypeChange(transitTimeType) {
    if (transitTimeType == GlobalConstants.CARRIER_PROVIDED_KEYWORD) {
      alert(GlobalConstants.TRANSIT_TIME_TYPE_ALERT_MESSAGE);
    }
  }

  private getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl('', Validators.required)
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  public onFileChange(event) {
    this.selectedFile = event.target.files[0];
  }

  public async submit() {
    // Creating Request Body
    let requestBody = JSON.parse(JSON.stringify(this.updateTransitTimeForm.value));

    let uploadBucket = this.commonUtils.getUploadBucket();
    requestBody[GlobalConstants.ARC] = this.commonUtils.getArc();
    requestBody[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    requestBody[GlobalConstants.COMPONENT_KEY_VALUE] = this.commonUtils.buildComponentKeyValue(requestBody[GlobalConstants.COMPONENT_KEY_VALUE], requestBody[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);

    let componentKeyValue = requestBody[GlobalConstants.COMPONENT_KEY_VALUE].replace(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR, GlobalConstants.SLASH);
    let key = requestBody[GlobalConstants.TRANSIT_TIME_TYPE] + GlobalConstants.SLASH + requestBody[GlobalConstants.BUSINESS_UNIT] + GlobalConstants.SLASH + requestBody[GlobalConstants.FROM_COUNTRY_CODE] + GlobalConstants.SLASH + componentKeyValue + GlobalConstants.SLASH + Math.round(Date.now() / 1000);
    requestBody[GlobalConstants.BUCKET] = uploadBucket;
    requestBody[GlobalConstants.KEY] = key;
    requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    requestBody[GlobalConstants.LOOK_UP_KEYS] = this.currentWorkingRecord[GlobalConstants.LOOK_UP_KEYS];
    delete requestBody[GlobalConstants.TRANSIT_TIME_FILE];
    console.log(JSON.stringify(requestBody));

    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions(requestBody);
      this.loading = false;
      if (hasPermission === false){
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }
    
    let metadata = this.commonUtils.generateMetadata(requestBody);
    // File Upload and call backend apis
    let promise = (this.uploadFileServiceUtils.uploadFile(uploadBucket, key, this.selectedFile, metadata));
    this.loading = true;
    await promise.then((data) => {
      this.loading = false;
      this.toastrService.success(GlobalConstants.FILE_UPLOAD_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS);
    }).catch((data) => {
      this.loading = false;
      this.toastrService.error(GlobalConstants.FILE_UPLOAD_FAILED, GlobalConstants.TITLE_ERROR);
      console.log(data)
    });

  }
}

